import { createContext, useContext } from "react";
import { StoreApi, useStore } from "zustand";

export interface AppInsightsStore {
  getSessionId: () => string | undefined;
  trackException: (exception: Error) => void;
  addAuthenticatedUserContext: (userId: string) => void;
  trackEvent: (name: string, properties?: { [key: string]: string }) => void;
}
export const AppInsightsContext = createContext<StoreApi<AppInsightsStore> | null>(null);

export function useAppInsights<U>(selector: (store: AppInsightsStore) => U): U {
  const context = useContext(AppInsightsContext);
  if (!context) {
    throw new Error('useAppInsights must be used within a AppInsightsProvider');
  }
  return useStore(context, selector);
}
